export default function test(to) {
  let form =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset; //获取滚动条的高度(兼容三种浏览器版本)
  let val = (to - form) / 30;
  let index = 0;
  let ti = setInterval(() => {
    form += val;
    document.documentElement.scrollTop = form;
    document.body.scrollTop = form;
    window.pageYOffset = form;
    index++;
    if (index === 30) clearInterval(ti);
  }, 2);
}
